import React, { useEffect, useRef, useState } from "react";
import style from "./Home.module.css";
import ArrowCircleRightIcon from "@mui/icons-material/ArrowCircleRight";
import Video_background from "../../assets/videos/BackGround.mp4";
import WhyAspImg from "../../assets/home_images/aspiron_img.png";
import "animate.css";
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import anuragEng from "../../assets/CLIENTS/anuragEng.png";
import bvc from "../../assets/CLIENTS/bvc.jpg";
import bvces from "../../assets/CLIENTS/bvces.jpg";
import BVCITS from "../../assets/CLIENTS/BVCITS.jpg";
import ISTS from "../../assets/CLIENTS/ISTS.jpg";
import methodist from "../../assets/CLIENTS/methodist.jpg";
import mittapalli from "../../assets/CLIENTS/mittapalli.jpg";
import PSCMR from "../../assets/CLIENTS/PSCMR.png";
import RAMIREDDY from "../../assets/CLIENTS/RAMIREDDY.jpg";
import RVIT from "../../assets/CLIENTS/RVIT.jpg";
import samskruthiPharma from "../../assets/CLIENTS/samskruthiPharma.jpg";
import samskruthiPolytech from "../../assets/CLIENTS/samskruthiPolytech.PNG";
import SamskrutiEC from "../../assets/CLIENTS/SamskrutiEC.jpg";
import SRKIT from "../../assets/CLIENTS/SRKIT.png";
import swarnandhra from "../../assets/CLIENTS/swarnandhra.jpeg";
import vignan from "../../assets/CLIENTS/vignan.png";
import AOS from "aos";
import "aos/dist/aos.css";
import Testimonial from "../Testimonal/Testimonial";
import Modules from "./Modules";


const texts = [
  "ERP",
  "OBE",
  "NAAC",
  "NIRF",
  "DIGITAL EVALUATION",
  "SMART ATTENDENCE",
];
const Home = () => {
  const [products, setProducts] = useState(0);
  const [projects, setProjects] = useState(0);
  const [clients, setClients] = useState(0);
  const [employees, setEmployees] = useState(0);
  const sectionRef = useRef(null);
  const [currentTextIndex, setCurrentTextIndex] = useState(0);
  const [animationClass, setAnimationClass] = useState("animate__flipInX");


  const animateCounter = (target, setState, duration) => {
    let current = 0;
    const increment = target / (duration / 10);
    const interval = setInterval(() => {
      current += increment;
      if (current >= target) {
        current = target;
        clearInterval(interval);
      }
      setState(Math.floor(current));
    }, 10);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setAnimationClass("animate__flipOutX");
      setTimeout(() => {
        setCurrentTextIndex((prevIndex) => (prevIndex + 1) % texts.length);
        setAnimationClass("animate__flipInX");
      }, 1000);
    }, 4000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          console.log("Section is visible. Animating counters...");
          setProducts(0);
          setProjects(0);
          setClients(0);
          setEmployees(0);
          animateCounter(15, setProducts, 1000);
          animateCounter(2, setProjects, 1000);
          animateCounter(40, setClients, 1500);
          animateCounter(100, setEmployees, 2000);
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    } else {
      console.error("sectionRef is not attached to any element!");
    }

    return () => {
      if (observer && sectionRef.current) observer.disconnect();
    };
  }, []);
  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <div
      style={{
        width: "100%",
        overflow:"hidden",
        cursor: "url(C:/Users/Adiversa-5/Downloads/circle-outline.svg),auto",
      }}
    >
      <div>
        <video autoPlay loop muted className={style.backgroundVideo}>
          <source src={Video_background} type="video/mp4" />
          Your browser does not support the video tag.
        </video>

        <div className={style.MuiHome}>
          <div>
            <h1 className={style.Home_text}>
              Empowering <span style={{ fontWeight: "100" }}>Institutions</span>{" "}
              <br />
              Across India <span style={{ fontWeight: "100" }}> with </span>
              <br/>
              <span
                className={`${style.animatedText} animate__animated ${animationClass}`}
                key={currentTextIndex}
              >
                {texts[currentTextIndex]}
              </span>
            </h1>
            <br />

            <p className={style.Paratext}>
              Aspiron revolutionizes institutional management, streamlining
              everything from onboarding to alumni engagement. We transforms
              institutions, ensuring NAAC,NIRF,NBA compliance and driving
              excellence in India’s education sector.
            </p>
          </div>
          <br />
          <a
            href="https://calendly.com/aspiron-technologies1/30min"
            target="_blank"
            rel="noreferrer"
          >
            <button className={style.a_button}>
              Get Demo
              <span
                style={{
                  textAlign: "end",
                  marginLeft: "25px",
                  display: "inline-block",
                  transition: "transform 0.3s ease",
                }}
                className={style.arrow_icon}
              >
                <ArrowCircleRightIcon sx={{ fontSize: "30px" }} />
              </span>
            </button>
          </a>
        </div>
      </div>

      <div className="">
        <div className={style.main_div}>
          <div className={style.paradiv}>
            <p className={style.accord_div}>
              Why to
              <br />
              <span>
                Choose{" "}
                <span
                  className="accord_a"
                  style={{
                    color: " #FF9800",
                    textShadow: "-5px 0px 5px rgba(0,0,0,0.6)",
                  }}
                >
                  A
                </span>
                <span
                  className="accord_a"
                  style={{ textShadow: "-5px 0px 5px rgba(0,0,0,0.6)" }}
                >
                  spir
                </span>
                <span
                  className="accord_a"
                  style={{
                    color: " #FF9800",
                    textShadow: "-5px 0px 5px rgba(0,0,0,0.6)",
                  }}
                >
                  o
                </span>
              </span>
              <span
                className="accord_a"
                style={{ textShadow: "-5px 0px 5px rgba(0,0,0,0.6)" }}
              >
                n
              </span>
            </p>
            <br />
            <p className={style.txtmsg}>
              Our team consists of experts with a deep understanding of the
              unique challenges faced by educational institutions. We thrive on
              innovation, constantly exploring new technologies and
              methodologies to stay at the forefront of educational software
              development.
            </p>
          </div>
          <div className={style.img_div}>
            <img src={WhyAspImg} alt="img"/>
          </div>
        </div>
      </div>
      <div>
        <Modules />
      </div>
      <br />

      <div>
        <Testimonial />
      </div>

      <div className={style.clients_container}>
        <div style={{ width: "100%", padding: "10px 10px", color: "black" }}>
          <div>
            <div>
              <h1
                style={{ fontWeight: "bolder" }}
                className={style.Clients_trusted}
              >
                Our Trusted Clients
              </h1>
            </div>
          </div>
        </div>
        <div>
          <marquee
            behavior="scroll"
            direction="left"
            scrollamount="15"
            style={{ padding: "30px" }}
          >
            <div className={style.marquee_div}>
              <div style={{ width: "100%" }}>
                <img src={anuragEng} alt="first" className={style.c_img} />
              </div>
              <div style={{ width: "100%" }}>
                <img src={bvc} alt="second" className={style.c_img} />
              </div>
              <div style={{ width: "100%" }}>
                <img src={bvces} alt="third" className={style.c_img} />
              </div>
              <div style={{ width: "100%" }}>
                <img src={BVCITS} alt="fourth" className={style.c_img} />
              </div>
              <div style={{ width: "100%" }}>
                <img src={ISTS} alt="fourth" className={style.c_img} />
              </div>
              <div style={{ width: "100%" }}>
                <img src={methodist} alt="fourth" className={style.c_img} />
              </div>
              <div style={{ width: "100%" }}>
                <img src={mittapalli} alt="fourth" className={style.c_img} />
              </div>
              <div style={{ width: "100%" }}>
                <img src={PSCMR} alt="fourth" className={style.c_img} />
              </div>
              <div style={{ width: "100%" }}>
                <img src={RAMIREDDY} alt="fourth" className={style.c_img} />
              </div>
              <div style={{ width: "100%" }}>
                <img src={RVIT} alt="fourth" className={style.c_img} />
              </div>
              <div style={{ width: "100%" }}>
                <img
                  src={samskruthiPharma}
                  alt="fourth"
                  className={style.c_img}
                />
              </div>
              <div style={{ width: "100%" }}>
                <img
                  src={samskruthiPolytech}
                  alt="fourth"
                  className={style.c_img}
                />
              </div>
              <div style={{ width: "100%" }}>
                <img src={SamskrutiEC} alt="fourth" className={style.c_img} />
              </div>
              <div style={{ width: "100%" }}>
                <img src={SRKIT} alt="fourth" className={style.c_img} />
              </div>
              <div style={{ width: "100%" }}>
                <img src={swarnandhra} alt="fourth" className={style.c_img} />
              </div>
              <div style={{ width: "100%" }}>
                <img src={vignan} alt="fourth" className={style.c_img} />
              </div>
            </div>
          </marquee>
        </div>
      </div>

      <br />

      <div ref={sectionRef} className={style.Clients}>
        <div className="Footerdiv" style={{ margin: "auto" }}>
          <b>
            <h4  className={style.counterStyle}>
              <span>{products}</span>
              <b>
                <span>+</span>
              </b>
            </h4>
          </b>
          <b>
            <h6>Products</h6>
          </b>
        </div>
        <div style={{ margin: "auto" }}>
          <b>
            <h4 className={style.counterStyle}>
              <span>{projects}</span>
              <b>
                <span>+</span>
              </b>
            </h4>
          </b>
          <b>
            <h6>Projects</h6>
          </b>
        </div>
        <div style={{ margin: "auto" }}>
          <b>
            <h4 className={style.counterStyle}>
              <span>{clients}</span>
              <b>
                <span>+</span>
              </b>
            </h4>
          </b>
          <b>
            <h6>Clients</h6>
          </b>
        </div>
        <div style={{ margin: "auto" }}>
          <b>
            <h4 className={style.counterStyle}>
              <span>{employees}</span>
              <b>
                <span>+</span>
              </b>
            </h4>
          </b>
          <b>
            <h6>Employees</h6>
          </b>
        </div>
      </div>
    </div>
  );
};

export default Home;
